<template>
  <div>
    <div ref="vaptcha">
      <div class="vaptcha-init-main">
        <div class="vaptcha-init-loading">
          <a href="https://www.vaptcha.com/" target="_blank">
            <svg
              height="60px"
              style="
                enable-background: new 0 0 50 50;
                width: 14px;
                height: 14px;
                vertical-align: middle;
              "
              viewBox="0 0 24 30"
              width="48px"
              xml:space="preserve"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <rect fill="#CCCCCC" height="12.5469" width="4" x="0" y="9.22656">
                <animate
                  attributeName="height"
                  attributeType="XML"
                  begin="0s"
                  dur="0.6s"
                  repeatCount="indefinite"
                  values="5;21;5"
                ></animate>
                <animate
                  attributeName="y"
                  attributeType="XML"
                  begin="0s"
                  dur="0.6s"
                  repeatCount="indefinite"
                  values="13; 5; 13"
                ></animate>
              </rect>
              <rect
                fill="#CCCCCC"
                height="20.5469"
                width="4"
                x="10"
                y="5.22656"
              >
                <animate
                  attributeName="height"
                  attributeType="XML"
                  begin="0.15s"
                  dur="0.6s"
                  repeatCount="indefinite"
                  values="5;21;5"
                ></animate>
                <animate
                  attributeName="y"
                  attributeType="XML"
                  begin="0.15s"
                  dur="0.6s"
                  repeatCount="indefinite"
                  values="13; 5; 13"
                ></animate>
              </rect>
              <rect
                fill="#CCCCCC"
                height="13.4531"
                width="4"
                x="20"
                y="8.77344"
              >
                <animate
                  attributeName="height"
                  attributeType="XML"
                  begin="0.3s"
                  dur="0.6s"
                  repeatCount="indefinite"
                  values="5;21;5"
                ></animate>
                <animate
                  attributeName="y"
                  attributeType="XML"
                  begin="0.3s"
                  dur="0.6s"
                  repeatCount="indefinite"
                  values="13; 5; 13"
                ></animate>
              </rect>
            </svg>
          </a>
          <span class="vaptcha-text">VAPTCHA启动中...</span>
        </div>
      </div>
    </div>
    如果验证码弹出异常，请在浏览器设置中允许 "弹出式窗口"
  </div>
</template>

<script>
import { loadV2Script, optionsMerge } from "./util";

export default {
  name: "Vaptcha",
  props: {
    vid: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "click",
    },
    scene: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      vaptcha: null,
    };
  },
  mounted() {
    const config = {
      container: this.$refs.vaptcha,
    };
    Object.assign(config, this.$props);
    this.$vaptcha && optionsMerge(config, this.$vaptcha.options);
    loadV2Script().then(() => {
      window.vaptcha(config).then((obj) => {
        obj.listen("pass", () => {
          this.$emit("input", obj.getServerToken());
        });
        obj.render();
        this.vaptcha = obj;
      });
    });
  },
  /*    destroyed() {
            const { vaptcha } = this;
            vaptcha && vaptcha.destroy();
        }*/
};
</script>

<style>
.vaptcha-init-main {
  display: table;
  width: 100%;
  height: 100%;
  min-height: 36px;
  background-color: #eeeeee;
}

.vaptcha-init-main .vaptcha-init-loading {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.vaptcha-init-main a {
  display: inline-block;
  width: 18px;
  height: 18px;
}

.vaptcha-init-main img {
  vertical-align: middle;
}

.vaptcha-text {
  font-family: sans-serif;
  font-size: 12px;
  color: #cccccc;
  vertical-align: middle;
}
</style>